import { takeLatest, takeEvery, put, call } from "redux-saga/effects";
import apiCall from "../services"
import config from '../config/config.json';


const endpoint = `${config.credentials.url}/country-code`;

function* countrycode(actions) {
    try {
        const headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${actions.access}`,
        };

        const requestOptions = {
            headers: headers,
        };

        const url = `${endpoint}/${actions.query}/`;

        const response = yield call(apiCall, "GET", url, requestOptions);

        const normalized =
            response?.id === undefined && response?.id_country_code !== undefined
                ? { ...response, id: response.id_country_code }
                : response;

        yield put({ type: "COUNTRYCODE_RESPONSE", value: normalized });
    } catch (error) {
        yield put({ type: "COUNTRYCODE_RESPONSE", error: error });
    }
}

function* countrycodes(actions) {
    try {
        const headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${actions.access}`,
        };

        const requestOptions = {
            headers: headers,
        };

        const limit = actions.limit || 10;
        const url = actions.query ? `${endpoint}/${actions.query}` : `${endpoint}/?offset=0&limit=${limit}`;

        const response = yield call(apiCall, "GET", url, requestOptions);

        yield put({ type: "COUNTRYCODE_RESPONSE_LIST", value: response });
    } catch (error) {
        yield put({ type: "COUNTRYCODE_RESPONSE_LIST", error: error });
    }
}

function* add(actions) {
    try {
        const headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${actions.access}`,
        };
        const requestOptions = {
            headers: headers,
            body: JSON.stringify(actions.data),
        };

        const response = yield call(
            apiCall,
            "POST",
            `${endpoint}/`,
            requestOptions
        );

        yield put({ type: "COUNTRYCODE_RESPONSE", value: response, type_op: "create" });
    } catch (error) {
        yield put({ type: "COUNTRYCODE_RESPONSE", error: error, type_op: "create" });
    }
}

function* remove(actions) {
    try {
        const headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${actions.access}`,
        };

        const requestOptions = {
            headers: headers,
        };

        const response = yield call(
            apiCall,
            "DELETE",
            `${endpoint}/${actions.data}/`,
            requestOptions
        );

        yield put({ type: "COUNTRYCODE_RESPONSE", value: response, type_op: "delete" });
    } catch (error) {
        yield put({ type: "COUNTRYCODE_RESPONSE", error: error, type_op: "delete" });
    }
}

function* edit(actions) {
    try {
        const headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${actions.access}`,
        };

        const requestOptions = {
            headers: headers,
            body: JSON.stringify(actions.data),
        };

        const response = yield call(
            apiCall,
            "PATCH",
            `${endpoint}/${actions.id}/`,
            requestOptions
        );

        yield put({ type: "COUNTRYCODE_RESPONSE", value: response, type_op: "update" });
    } catch (error) {
        yield put({ type: "COUNTRYCODE_RESPONSE", error: error, type_op: "update" });
    }
}

export function* getCountryCode() {
    yield takeEvery("GET_COUNTRYCODE", countrycode);
}

export function* getCountryCodeList() {
    yield takeEvery("GET_COUNTRYCODES", countrycodes);
}

export function* addCountryCode() {
    yield takeEvery("ADD_COUNTRYCODE", add);
}

export function* removeCountryCode() {
    yield takeEvery("REMOVE_COUNTRYCODE", remove);
}

export function* editCountryCode() {
    yield takeEvery("EDIT_COUNTRYCODE", edit);
}
